import React, { useState, useEffect } from "react";
import axios from "axios";

const Autocomplete = ({ onSelectLocalBody, resetTrigger }) => {
  const [data, setData] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  // Add this effect to clear input when resetTrigger changes
  useEffect(() => {
    setInputValue('');
  }, [resetTrigger]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.PUBLIC_URL}/assets/local-bodies.json`);
        setData(response.data);
      } catch (error) {
        console.error("Error fetching local bodies:", error);
      }
    };

    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (value) {
      const filteredSuggestions = data
        .filter((item) =>
          item?.name?.toLowerCase().includes(value.toLowerCase())
        )
        .map((item) => ({
          formattedName: `${item.name || ''} - ${item.localBodyType || ''}`,
          ...item,
        }));

      setSuggestions(filteredSuggestions);
    } else {
      setSuggestions([]);
    }
  };

  // useEffect(() => {
  //   setData(localBodies);
  // }, [localBodies]);

  const handleSuggestionClick = (suggestion) => {
    setInputValue(suggestion.formattedName);
    setSuggestions([]);
    // Pass the entire suggestion object, not just the ID
    onSelectLocalBody(suggestion);
  };

  return (
    <div style={{ width: "300px", position: "relative", display: "flex", alignItems: "center" }}>
      <div style={{position: "absolute", left: "10px", top: "50%", transform: "translateY(-50%)", color: "#999", pointerEvents: "none"}}><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M9.53033 9.54073L13 13M11 6C11 8.7614 8.7614 11 6 11C3.23857 11 1 8.7614 1 6C1 3.23857 3.23857 1 6 1C8.7614 1 11 3.23857 11 6Z" stroke="black" strokeOpacity="0.71" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg></div>
      <input
        type="text"
        id="autocomplete"
        value={inputValue}
        onChange={handleInputChange}
        style={{
          width: "100%",
          padding: "1px 8px 0 30px",
          borderRadius: "4px",
          border: "1px solid #ccc",
          boxSizing: "border-box",
          fontSize: "12px",
          height: "26px",
        }}
        autoComplete="off"
        placeholder="Search by Local Body"
      />
      {suggestions.length > 0 && (
        <ul
          style={{
            listStyleType: "none",
            padding: "0",
            margin: "5px 0 0",
            border: "1px solid #ccc",
            borderRadius: "4px",
            maxHeight: "150px",
            overflowY: "auto",
            backgroundColor: "white",
            position: "absolute",
            top: "20px",
            width: "100%",
            zIndex: "10",
            fontSize: "12px",
          }}
        >
          {suggestions.map((suggestion, index) => (
            <li
              key={index}
              onClick={() => handleSuggestionClick(suggestion)}
              style={{
                padding: "8px",
                cursor: "pointer",
                borderBottom: "1px solid #eee",
              }}
            >
              {suggestion.formattedName}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Autocomplete;